import axios from 'axios';

const prepaidHealths = `${process.env.REACT_APP_BASE_URL}/services/parametrics/api/prepaid-healths/`;
const prepaidHealthsCategories = `${process.env.REACT_APP_BASE_URL}/services/parametrics/api/prepaid-health-categories/`;

function urlManager(url = null, product = null) {
  if (url !== null){
    let urlManager = url
    if (product !== null) {
      urlManager = `${process.env.REACT_APP_BASE_URL}/proxy/${product}/services${urlManager.split('/services').pop()}`
    }
    return urlManager
  }
}

export const getSocialWork = async (token, displayError = () => {}) => {
    let url = `${prepaidHealths}`
    return await axios.get(url,{ headers: {authorization: `Bearer ${token}`}} )
    .then((response) => {
        return response.data;
    })
    .catch((error) => {
        if(token) displayError("getSocialWork error: " + error.message)
    });
}

export const getSocialWorkCategory = async (token, displayError = () => {}, id) => {
    let url = `${prepaidHealthsCategories}prepaid/${id}`
    return await axios.get(url,{ headers: {authorization: `Bearer ${token}`}} )
    .then((response) => {
        return response.data;
    })
    .catch((error) => {
        if(token) displayError("getSocialWork error: " + error.message)
    });
}

export const postSocialWork = async (token, displayError = () => {}, json) => {
    let url = `${urlManager(prepaidHealths,'mediline')}`
    return await axios.post(url,json,{ headers: {authorization: `Bearer ${token}`}})
    .then((response) => {
        return response.data;
    })
    .catch((error) => {
        if (error?.response?.data?.message){
            displayError(error?.response?.data?.message);
        }else{
            if(token) displayError("postSocialWork error: " + error.message);
        }
    });
}

export const postSocialWorkCategory = async (token, displayError = () => {}, json) => {
    let url = `${urlManager(prepaidHealthsCategories,'mediline')}`
    return await axios.post(url,json,{ headers: {authorization: `Bearer ${token}`}})
    .then((response) => {
        return response.data;
    })
    .catch((error) => {
        if (error?.response?.data?.message){
            displayError(error?.response?.data?.message);
        }else{
            if(token) displayError("postSocialWorkCategory error: " + error.message);
        }
    });
}

export const putSocialWork = async (token, displayError = () => {}, json, id) => {
    let url = `${urlManager(prepaidHealths,'mediline')}${id}`
    return await axios.put(url,json,{ headers: {authorization: `Bearer ${token}`}})
    .then((response) => {
        return response.data;
    })
    .catch((error) => {
        if (error?.response?.data?.message){
            displayError(error?.response?.data?.message);
        }else{
            if(token) displayError("postSocialWork error: " + error.message);
        }
    });
}

export const putSocialWorkCategory = async (token, displayError = () => {}, json, id) => {
    let url = `${urlManager(prepaidHealthsCategories,'mediline')}/${id}`
    return await axios.put(url,json,{ headers: {authorization: `Bearer ${token}`}})
    .then((response) => {
        return response.data;
    })
    .catch((error) => {
        if (error?.response?.data?.message){
            displayError(error?.response?.data?.message);
        }else{
            if(token) displayError("postSocialWorkCategory error: " + error.message);
        }
    });
}